import { useNavigate } from "react-router-dom";
import { useHeaderLogic } from "../../hooks/useHeaderLogic";
import { IoExitOutline } from "react-icons/io5";
import { MdOutlineWorkspacePremium } from "react-icons/md";
import { FaRegUserCircle } from "react-icons/fa";
import { GrStorage } from "react-icons/gr";
import "./UserCart.css";
import { useHeaderNavigation } from "../../hooks/useHeaderNavigation";

const UserCart = ({ userEmail, style, onClick }) => {
  const navigate = useNavigate();
  const { logout } = useHeaderLogic();
  const {navigateToStorage} = useHeaderNavigation();

  const handleBuySubscription = () => {
    navigate("/subscription", { state: { paymentType: "subscription" } });
  };

  const handleUserProfile = () =>{
    navigate('/profile')
  }

  return (
    <div className="usercart" style={style} onClick={onClick}>
        <div className="header">Учетная Запись</div>
      <div className="usercart-upper">
        <div className="email">
          <FaRegUserCircle className="icons"/>
          <div onClick={handleUserProfile}>Личный кабинет</div>
        </div>

        <div className="storage" onClick={()=>navigateToStorage()}>
          <GrStorage className="icons"/>
          <div>Хранилище</div>
        </div>

        <div className="subscriptionn" onClick={handleBuySubscription}>
          <MdOutlineWorkspacePremium className="icons"/>
          <div>Обновить тариф</div>
        </div>
      </div>

      <div className="usercart-bottom" onClick={logout}>
        <IoExitOutline className="icons"/>
        <div>Выйти</div>
      </div>
    </div>
  );
};

export default UserCart;
